import React, { useState, useEffect } from 'react';
import './styles/login.css';
import { Link, useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { userLoginAndAuthentication } from '../redux/actions/userAction';
import { saveReturnTo, leaveForReturnTo } from '../Auth/returnTo';

function Login() {
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({ username: '', password: '' });
    const [localError, setLocalError] = useState('');

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loading: loadingDetails, error: errorDetails, auth: isAuth, token: authToken, needs2FA } = useSelector(state => state.user);

    // Navigate when 2FA is required
    useEffect(() => {
        if (needs2FA) {
            navigate('/verify-2fa');
        }
    }, [needs2FA, navigate]);

    // Navigate when authentication succeeds: back to the app that sent the user here (Octopus), or home
    useEffect(() => {
        saveReturnTo();
        const auth = isAuth || localStorage.getItem('auth');
        if (auth && !leaveForReturnTo()) {
             window.location.href = `/product/#/home`;
        }
    }, [isAuth, authToken]);

    // Show backend errors
    useEffect(() => {
        if (errorDetails) {
            // Customize error messages
            if (errorDetails.includes("401") || errorDetails.toLowerCase().includes("invalid")) {
                setLocalError("Username or password is incorrect.");
            } else if (errorDetails.toLowerCase().includes("network")) {
                setLocalError("Network error. Please check your connection.");
            } else {
                setLocalError("Something went wrong. Please try again.");
            }
        }
    }, [errorDetails]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setLocalError(''); // clear error while typing
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.username || !formData.password) {
            setLocalError("Please enter both username and password.");
            return;
        }
        dispatch(userLoginAndAuthentication(formData.username, formData.password));
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="login-screen-container">
            <div className="d-flex justify-content-center align-items-center mt-4">
                <div className="d-flex justify-content-center align-items-center w-100">
                    <div className="login-form">
                        <form className="login-form" onSubmit={handleSubmit}>
                            <h2 className="my-4" style={{ userSelect: "none" }}>Sign in</h2>

                            <div className="form-data mt-5">
                                <div className="form-group">
                                    <input
                                        className={`input-Box ${localError ? "input-error" : ""}`}
                                        type="text"
                                        id="username"
                                        name="username"
                                        value={formData.username}
                                        onChange={handleChange}
                                        required
                                        placeholder="Username"
                                    />
                                </div>
                                <div className="form-group password-group">
                                    <input
                                        className={`input-Box ${localError ? "input-error" : ""}`}
                                        type={showPassword ? 'text' : 'password'}
                                        id="password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        required
                                        placeholder="Password"
                                    />
                                    <span className="eye-icon" onClick={togglePasswordVisibility}>
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>
                            </div>

                            {/* Error message */}
                            {localError && <p className="error-message text-danger mt-2">{localError}</p>}

                            <button type="submit" className="login-button" disabled={loadingDetails}>
                                {loadingDetails ? 'Signing in...' : 'Sign in'}
                            </button>

                            <div className="mt-5">
                                <div className="d-flex justify-content-center align-items-center">
                                    <h6>Not an account yet?</h6>
                                    <Link to="/register"><h6 className="mx-2">Register</h6></Link>
                                </div>
                                <div className="d-flex justify-content-center align-items-center">
                                    <Link to="/password-reset"><h6>Forgot your Password?</h6></Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
